var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCarrinho01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    d: "M27.2,35.1H8.8c-1.6,0-3-1.1-3.4-2.6l-4.9-18c-0.3-0.9,0.3-1.9,1.2-2.1c0.1,0,0.3-0.1,0.5-0.1h2.5l6.5-11.4 l3,1.7l-5.5,9.6h18.5l-5.5-9.6l3-1.7l6.5,11.4h2.5c1,0,1.8,0.8,1.8,1.7c0,0.2,0,0.3-0.1,0.5l-4.9,18C30.1,34,28.8,35.1,27.2,35.1z  M4.5,15.8l4.3,15.8h18.3l4.3-15.8H4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2_3_",
    d: "M23.3,28.1h-3.5v-8.8h3.5V28.1z M16.2,28.1h-3.5v-8.8h3.5V28.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCarrinho01);
export default __webpack_public_path__ + "static/media/ico-carrinho-01.8fa690803f2e45692113011db87b335e.svg";
export { ForwardRef as ReactComponent };